var map = {
	"./10_yellow.mp3": "d737",
	"./11_green.mp3": "4b2a",
	"./8_blue.mp3": "cdb8",
	"./9_red.mp3": "c66c",
	"./M_Brilliant.mp3": "d169",
	"./M_Excellent.mp3": "cf15",
	"./M_Fantastic.mp3": "9a9a",
	"./M_Great.mp3": "dff0",
	"./M_Perfect.mp3": "18fd",
	"./M_Think again.mp3": "66b6",
	"./M_Try again.mp3": "b6a0",
	"./M_Very good.mp3": "9bfa",
	"./M_Well done.mp3": "81fc",
	"./M_Work harder.mp3": "a878",
	"./click.mp3": "1d41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f0d";